module.exports = __webpack_public_path__ + "static/assets/db44f653e9a6e74e31c4af1341b7a095.png";